import FAQ from "../../FAQ/FAQ";
import Quote from "../../Quote/Quote";

class ContentFaqList {
  constructor(contentfulNode) {
    this.questions = contentfulNode?.questions ? contentfulNode?.questions.map(question => new FAQ(question)) : [];
    this.quotes = contentfulNode?.quoteCarousel ? contentfulNode?.quoteCarousel.map(quote => new Quote(quote)) : [];
    this.type = 'CONTENT_FAQ_LIST';
  }
}

export { ContentFaqList };
